import Initialiser from 'initialiser';
import { cloneDeep } from 'utils/immutable';

// ACTION TYPES
const OPEN_UPLOAD_MODAL = 'OPEN_UPLOAD_MODAL';
const CLOSE_UPLOAD_MODAL = 'CLOSE_UPLOAD_MODAL';

// SYNC ACTION CREATORS
export function openUploadModal() {
    return { type: OPEN_UPLOAD_MODAL };
}
export function closeUploadModal() {
    return { type: CLOSE_UPLOAD_MODAL };
}

// REDUCERS
export default function reducer(state = Initialiser.initialState.upload, action) {
    switch (action.type) {
        case OPEN_UPLOAD_MODAL:
            return cloneDeep({ modalOpen: true });
        case CLOSE_UPLOAD_MODAL:
            return cloneDeep({ modalOpen: false });
        default: {
            return state;
        }
    }
}
